// for hero section
export const heroSectionData = [
  {
    title: "Society Alpha Island Club",
    description:
      "The Society Alpha Island Club Was Created To Give Smaller Investors Access to Bigger Projects Through Fractional Ownership of a Portfolio of NFTs/Crypto/ICO's & IRL Investments.",
    button: ["join the club", "0.14 ETH + GAS"],
    counter: [
      {
        number: 1000,
        text: "available",
      },
      {
        number: 1,
        text: "ownership",
      },
      {
        number: 105,
        text: "auctions",
      },
    ],
    image:
      "https://moosesocietynft.io/wp-content/uploads/2022/05/Capture32.png",
  },
];
// islanc club section
export const islandClubData = [
  {
    image:
      "https://moosesocietynft.io/wp-content/uploads/2022/05/Capture354-cutout.png",
    subTitle: "ALPHA",
    title: "ISLAND CLUB",
    description:
      "We all have great ideas and investment projects you like but just cant afford to get into. With the Island Club, you can bring up your ideas and let the group vote on them. Anonymously.",
    button: ["learn more >"],
  },
];
// islanc drops section
export const islandDropsData = [
  {
    subTitle: "Moose Society Alpha Island Club",
    title: "The Island Drops",
    description:
      "We will be releasing 3 drops. Each color coded to reflect when you entered the fund and gives a proper role in the discord. There are NO special rewards for each color.",
    images: [
      {
        img: "https://moosesocietynft.io/wp-content/uploads/2022/05/Capture32-cutout.png",
        text: "#01 - #33",
      },
      {
        img: "https://moosesocietynft.io/wp-content/uploads/2022/05/Capture354-cutout.png",
        text: "#34 - #66",
      },
      {
        img: "https://moosesocietynft.io/wp-content/uploads/2022/05/Capture.png",
        text: "#67 - #100",
      },
    ],
  },
];
// procceds from section
export const proceedsFromData = [
  {
    subTitle: "Allocation Of",
    title: "Proceeds From A Trade",
    description:
      "We will take the profits from the fund and allocate them below. Each being paid from the treasury account controlled by the DAO.",
    nft_contents: [
      {
        count: "01",
        percent: "60%",
        description:
          "Directly back into the fund to keep growing the DAO. We want this to be a long term investment.",
      },
      {
        count: "02",
        percent: "20%",
        description:
          "Marketing fund directly for Alpha shares. We will take this and use it to help grow the secondary market.",
      },
      {
        count: "03",
        percent: "10%",
        description:
          "We will make a quarterly donation to the Children's Hospital. We started with the kids in mind, let's keep it that way!",
      },
      {
        count: "04",
        percent: "10%",
        description:
          "Someone need to run this fund. This money is for the management team to keep everything up and running.",
      },
    ],
    image:
      "https://moosesocietynft.io/wp-content/uploads/2022/04/Purple-Neon-Gradient-Cyber-Monday-Poster.jpg",
  },
];

// allocaion section
export const allocationData = [
  {
    subTitle: "Alpha Island Club",
    title: "Allocation Of Proceeds",
    description:
      "If any particular trade results in a gain, 100% of the cost basic of the trade goes back into the fund for the next investment.",
    accordions: [
      {
        id: "4fd5f5d",
        title: "50%",
        text: "50% of the gain on a trade goes right back into the fund, increasing the total buying power of the fund",
      },
      {
        id: "7sfe8ws",
        title: "35%",
        text: "35% of the gain gets distributed out via smart contract to all holders of the Alpha Island Club NFTs on once funds are settled in the fund wallet quarterly.",
      },
      {
        id: "df87s8f7s",
        title: "5%",
        text: "We will make a quarterly donation to the Children’s Hospital. We started with the kids in mind, let’s keep it that way!​",
      },
      {
        id: "d7sf5s",
        title: "5%",
        text: "Someone need to run this fund. This money is for the management team to keep everything up and running.​",
      },
      {
        id: "sf7s4fnvjuse",
        title: "5%",
        text: "5% goes to the initiator of the trade proposal that was approved",
      },
      {
        id: "8fdfs75ksj",
        title: "2%",
        text: "2% Royalties from secondary sales. 60% goes directly back into the fund to keep the pot growing 20% goes into a marketing fund directly for Alpha shares (to incentivize trading on secondary markets 10% goes to Children’s – Lets stick to the overall purpose of the organization from the beginning and keep giving to Children’s 10% goes to management of the Fund ",
      },
    ],
  },
];
// counter section
export const counterData = [
  "https://moosesocietynft.io/wp-content/uploads/2022/05/HURJTUHG.png",
  "https://moosesocietynft.io/wp-content/uploads/2022/05/HURJTUHG.png",
  "https://moosesocietynft.io/wp-content/uploads/2022/05/HURJTUHG.png",
  "https://moosesocietynft.io/wp-content/uploads/2022/05/HURJTUHG.png",
  "https://moosesocietynft.io/wp-content/uploads/2022/05/HURJTUHG.png",
];
